<div class="group-detail">

  <!-- Header card: identity + metadata + edit -->
  <section class="group-header-card" aria-label="User group details">
    <div class="group-identity">
      <mat-icon class="group-avatar" fontSet="material-icons-outlined" aria-hidden="true">supervised_user_circle</mat-icon>
      <div class="group-identity__text">
        <h1 class="group-name">{{ userGroup?.groupName }}</h1>
        @if (userGroup?.description) {
          <p class="group-description">{{ userGroup?.description }}</p>
        }
      </div>
    </div>

    <div class="group-meta">
      <dl class="group-meta__list">
        <div class="group-meta__item">
          <dt class="group-meta__label">Creation date</dt>
          <dd class="group-meta__value">{{ userGroup?.createAt || '—' }}</dd>
        </div>
        <div class="group-meta__item">
          <dt class="group-meta__label">Created by</dt>
          <dd class="group-meta__value">{{ userGroup?.createdBy || '—' }}</dd>
        </div>
      </dl>

      <button class="go-back group-edit-btn" type="button" (click)="editUserGroupModal()">
        <mat-icon>edit</mat-icon>
        EDIT
      </button>
    </div>
  </section>

  <!-- Members / Permissions tabs -->
  <section class="group-tabs" aria-label="Group configuration">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="MEMBERS">
        <app-usergroup-users #usersMembers [currentUserGroup]="this.userGroup"></app-usergroup-users>
      </mat-tab>
      <mat-tab label="PERMISSIONS">
        <app-permissions #permissionForm></app-permissions>
        <div class="tab-actions">
          <button (click)="saveAll()" [disabled]="isLoading" class="primary" mat-button type="button">
            @if (isLoading) {
              <mat-spinner diameter="18"></mat-spinner>
            } @else {
              <mat-icon>save</mat-icon>
            }
            SAVE PRIVILEGES
          </button>
        </div>
      </mat-tab>
    </mat-tab-group>
  </section>

  <!-- Sticky actions bar -->
  <div class="actions-bar">
    <button class="go-back" [routerLink]="['/app/usersGroup']" mat-button type="button">
      <mat-icon svgIcon="arrow-left-icon"></mat-icon>
      GO BACK
    </button>

    <div class="actions-bar__right">
      <button (click)="deleteGroup()" class="danger" mat-button type="button">
        <mat-icon>delete_outline</mat-icon>
        DELETE GROUP
      </button>
    </div>
  </div>

</div>
